import { urlSAC } from "../../lib/zentria";

/**
 * Boton de cotizar.
 *
 * Las cotizaciones no se atienden en esta web: van al portal SAC del propio
 * cliente (sac.aceroslima.com), que es donde estan los precios de corte,
 * plegado y rolado y donde caen las solicitudes. Antes habia aqui un cotizador
 * propio, con su propia logica y sus propios precios, que era una segunda
 * fuente de verdad para lo mismo.
 *
 * Todos los enlaces de cotizacion pasan por aqui para que el destino se cambie
 * en un solo sitio.
 */
export default function EnlaceCotizar({ className = "", children, ...resto }) {
  return (
    <a
      href={urlSAC()}
      className={className}
      target="_blank"
      rel="noopener noreferrer"
      {...resto}
    >
      {children}
    </a>
  );
}
